<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Aviso de privacidad</h1>

      <p>
        <i>Última actualización: 2 de abril de 2025</i>
      </p>

      <br />
      <p>
        En FEROS DINAFLEX, con domicilio digital en https://ferosdinaflex.online y correo de contacto contacto@ferosdinaflex.online, estamos comprometidos con la protección de los datos personales de nuestros usuarios, distribuidores y clientes. Este Aviso de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos su información personal, de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) en México.
      </p>

      <br />
      <h6>1. Identidad del Responsable</h6>
      <p>
        FEROS DINAFLEX es responsable del tratamiento de sus datos personales. Nuestro sitio web, sistema en la nube y plataforma de ecommerce están diseñados para la comercialización de productos saludables a través de un modelo de negocio de tipo multinivel.
      </p>

      <br />
      <h6>2. Datos Personales que Recabamos</h6>
      <p>
        Podemos recopilar los siguientes datos personales de forma directa o indirecta:
      </p>
      <ul>
        <li>Nombre completo</li>
        <li>Correo electrónico</li>
        <li>Número de teléfono</li>
        <li>Dirección de envío y facturación</li>
        <li>RFC y datos fiscales</li>
        <li>Información bancaria (para pagos, cobros o comisiones)</li>
        <li>Datos de contacto de referidos o patrocinadores (en caso de registro por invitación)</li>
        <li>Información sobre sus compras, pedidos y nivel dentro del esquema de distribución</li>
        <li>Datos de navegación y uso del sistema (cookies, IP, dispositivo, geolocalización)</li>
      </ul>

      <br />
      <h6>3. Finalidades del Tratamiento</h6>
      <p>
        Los datos personales serán utilizados para las siguientes finalidades principales:
      </p>
      <ul>
        <li>
          Crear y administrar su cuenta en la plataforma
        </li>
        <li>
          Procesar compras y pagos
        </li>
        <li>
          Emitir facturación electrónica
        </li>
        <li>
          Emitir facturación electrónica
        </li>
        <li>Calcular y distribuir comisiones</li>
        <li>Proveer acceso al sistema en la nube</li>
        <li>Brindar atención al cliente y soporte técnico</li>
        <li>Cumplir obligaciones legales y contractuales</li>
      </ul>

      <br />
      <p>
        Y para las siguientes finalidades secundarias:
      </p>
      <ul>
        <li>Envío de promociones y boletines</li>
        <li>Realización de encuestas de satisfacción</li>
        <li>Análisis de comportamiento de compra</li>
        <li>Mejora continua de la plataforma</li>
      </ul>

      <br />
      <h6>4. Transferencias de Datos</h6>
      <p>
        Sus datos podrán ser compartidos únicamente con:
      </p>
      <ul>
        <li>
          Proveedores de servicios tecnológicos, logísticos y financieros que colaboran con nosotros bajo cláusulas de confidencialidad
        </li>
        <li>
          Autoridades competentes cuando sea requerido por ley.<br />
          No vendemos ni rentamos su información a terceros ajenos a FEROS DINAFLEX.
        </li>
      </ul>

      <br />
      <h6>5. Derechos ARCO</h6>
      <p>
        Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales. Para ejercer estos derechos, deberá enviar una solicitud al correo: contacto@ferosdinaflex.online, indicando su nombre completo, el derecho que desea ejercer y cualquier documento que sustente su solicitud.
      </p>

      <br />
      <h6>6. Uso de Cookies y Tecnologías de Rastreo</h6>
      <p>
        Nuestro sitio y sistema en la nube utilizan cookies y otras tecnologías para analizar el tráfico, personalizar la experiencia del usuario y mejorar el servicio. Usted puede configurar su navegador para rechazar las cookies, aunque esto puede afectar algunas funcionalidades.
      </p>

      <br />
      <h6>7. Cambios al Aviso de Privacidad</h6>
      <p>
        Nos reservamos el derecho de modificar este Aviso de Privacidad en cualquier momento. Cualquier cambio será publicado en nuestro sitio web: https://ferosdinaflex.online. Recomendamos revisar periódicamente este documento.
      </p>

      <br />
      <h6>8. Contacto</h6>
      <p>
        Para cualquier duda o aclaración relacionada con este Aviso de Privacidad, puede escribirnos al correo:<br />
        <strong>contacto@ferosdinaflex.online</strong>
      </p>

    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
